import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { GoogleOAuthProvider } from "@react-oauth/google";

import "../excalidraw-app/sentry";

import ExcalidrawApp from "./App";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
const clientId = import.meta.env.VITE_APP_GOOGLE_CLIENT_ID;
root.render(
  <StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <ExcalidrawApp />
    </GoogleOAuthProvider>
  </StrictMode>,
);
